import { gql } from '@apollo/client/core';

export const GET_SNACKBAR_STATE = gql`
  {
    snackBar @client {
      type
      message
      isOpen
      duration
    }
  }
`;
